export default __webpack_public_path__ + "static/media/logo_lanchonete.bd81ace0.png";